import {API} from "@/Composables/api";

const updateUser = async (user, params = {}) => {
    return API.put(route("user.update", user.id), params, user);
};

const updatePreferences = async (user, preferences, params = {}) => {
    return API.put(route("user.preferences.update", user.id), params, preferences);
};

const deleteAvatar = async (profileId: string, avatarId: string) => {
    return API.delete(
        route("media.destroy", {
            modelType: "user-profile",
            modelId: profileId,
            collectionName: "avatars",
            mediaId: avatarId,
        }),
    );
};

export {updateUser, deleteAvatar, updatePreferences};
